import React, { useState, useEffect, useRef } from 'react';
import SpriteEl from '../SpriteEl/SpriteEl';
import { useSelector, useDispatch } from 'react-redux';
import { updateNote } from '../../notesSlice';
import { updateEditedNoteContent } from '../../notesSlice';

function Edit() {
	const {
		editedNoteContent
	} = useSelector(state => state.notes);
	const dispatch = useDispatch();

	// Local state to track textarea content
	const [note, setNote] = useState("");

	// Reference to the textarea element
	const textareaRef = useRef(null);

	const quitEditingHandler = (e) => {
		e.stopPropagation();
		dispatch(updateNote());
	}

	const handleNoteChange = (e) => {
		setNote(e.target.value);
		dispatch(updateEditedNoteContent(e.target.value));
	}

	useEffect(() => {
		setNote(editedNoteContent.note || "");
	}, [editedNoteContent]);

	return (

		<div className="notes__block notes__block--open-note">
			<button className="notes-back-button">
				<SpriteEl
					id="arrow-back-outline"
					onclick={(e) => quitEditingHandler(e)}
				/>
			</button>
			<div className="notes-open">
				<a href={editedNoteContent.post_url} className="notes-open__title">{editedNoteContent.post_title}</a>
				<textarea
					ref={textareaRef}
					className="notes-open__text"
					value={note}
					onChange={handleNoteChange}
				/>
			</div>
		</div>
	)
}

export default Edit;
